import {
  defaultResponseHandler,
  formatMs,
  useAssetConfig,
  useAssetParams,
  useAssetTranslation,
} from '@mss/mss-component-library';
import Fetch from '../../util/_fetch';
import { useQuery } from '@tanstack/react-query';

export function useDiscoveryQuery() {
  const { assetType } = useAssetParams();
  const { t } = useAssetTranslation();
  const { config } = useAssetConfig();

  return useQuery({
    queryKey: [assetType, 'discoveryAssets'],
    queryFn: async () =>
      config.discovery
        ?.dataParser(
          (
            await defaultResponseHandler<any[]>({
              t,
              request: Fetch.get(`/api/assets/discovery/${assetType}/`),
            })
          ).data ?? []
        )
        .sort(a => (a.is_hidden ? -1 : 1)),
    cacheTime: formatMs({ hours: 1 }),
    staleTime: formatMs({ hours: 1 }),
    refetchInterval: formatMs({ hours: 1 }),
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: true,
  });
}
